var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpSymbolikuvitus128057(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-5,.cls-6{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#6e6e6e;stroke-width:1.25px;}.cls-2,.cls-3,.cls-5{stroke-miterlimit:10;}.cls-3,.cls-4{fill:none;}.cls-3,.cls-4,.cls-5,.cls-6{stroke-linecap:round;}.cls-4,.cls-6{stroke-linejoin:round;}.cls-7{fill:#6e6e6e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 128,
    height: 128
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.14,71.38v8c0,5,4.66,7.18,8.86,7.18s8.86-2.21,8.86-7.18v-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.15,78.75,38,86.31c-7.3,3.23-11.92,9.9-11.92,17.21v9.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.85,78.75,90,86.31c7.3,3.23,11.92,9.9,11.92,17.21v9.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.13,36.41C88.13,54.31,70.14,54,64,54s-24.28.23-24.28-17.68S51.62,10.63,64,10.63C77.65,10.63,88.13,17.24,88.13,36.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85,55.37c3,.52,3.95-2.32,4.82-5.79,1.06-4.24-.26-6.68-3.25-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M43,55.37c-3,.52-4-2.32-4.82-5.79-1.06-4.24.26-6.68,3.25-7.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.53,38.08c0-.26,0-.52,0-.78C85,17.36,72,16.77,72,16.77s-1.55,7.34-8,7.46-8-7.48-8-7.48-13.84,2-14.55,20.56c0,.26,0,.51,0,.77,0,15.74,2.34,22.25,6.55,27.59S59.17,75,64,75s12.5-4,16.27-9.36S86.53,51.55,86.53,38.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.75,62.17a2.88,2.88,0,0,1-5.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.82,48.91l-1.88,5.58c-.17,1.17.15,1.9,1.91,2.22l2.25.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 74.57,
    y1: 39.08,
    x2: 79.67,
    y2: 39.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 48.33,
    y1: 39.08,
    x2: 53.43,
    y2: 39.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 51.62,
    cy: 46.37,
    r: 2.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 76.12,
    cy: 46.37,
    r: 2.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpSymbolikuvitus128057);
export default __webpack_public_path__ + "static/media/OP_symbolikuvitus_128_057.ea93c8f7f4648ed0b4bfb67d662b71f5.svg";
export { ForwardRef as ReactComponent };